import { InvoiceViewResponse } from '../services/staff-customer-view.service';

export type InvoiceOpenResult = 'opened' | 'unsupported' | 'empty';

export function openInvoiceView(view: InvoiceViewResponse): InvoiceOpenResult {
    const format = (view.format || '').toLowerCase();

    if (format === 'pdf' && view.contentBase64) {
        const blob = base64ToBlob(view.contentBase64.replace(/\s/g, ''), 'application/pdf');
        if (blob.size === 0) return 'empty';
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        return 'opened';
    }

    if (format === 'html' && view.html) {
        const blob = new Blob([view.html], { type: 'text/html;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        window.open(url, '_blank');
        return 'opened';
    }

    return 'unsupported';
}

function base64ToBlob(base64: string, mime: string): Blob {
    const bytes = atob(base64);
    const arr = new Uint8Array(bytes.length);
    for (let i = 0; i < bytes.length; i++) {
        arr[i] = bytes.charCodeAt(i);
    }
    return new Blob([arr], { type: mime });
}
